import React from 'react'
import { useField, useFormikContext } from 'formik'

import {
  Form,
  CardNumberInput,
  CardCVCInput,
  CardExpiryInput,
} from '@sketch/components'

const INPUT_BY_TYPE = {
  'card-number': CardNumberInput,
  'card-expiration': CardExpiryInput,
  'card-cvc': CardCVCInput,
}

export interface StripeFieldProps {
  className?: string
  name: string
  id: string
  label: string
  type: 'card-number' | 'card-expiration' | 'card-cvc'
  help?: string
}

const StripeField: React.FCC<StripeFieldProps> = props => {
  const { className, id, label, name, type, help } = props

  const [field, meta] = useField({ name, id })
  const { submitCount } = useFormikContext()
  const StripeInput = INPUT_BY_TYPE[type]

  const showError =
    meta.touched && (submitCount > 0 || (meta.value && !meta.value.empty))

  return (
    <Form.StripeField
      className={className}
      htmlFor={id}
      label={label}
      errorText={showError ? meta.error : undefined}
      help={help}
    >
      <StripeInput
        id={id}
        invalid={!!(showError && meta.error)}
        onChange={value => field.onChange({ target: { name, value } })}
        onBlur={() => field.onBlur({ target: { name } })}
      />
    </Form.StripeField>
  )
}

export default StripeField
